
















































import { Message } from "element-ui";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestCustomDialog extends Vue {
  @Prop()
  visible?:any;

  @Prop()
  config?:any;

  chooseResult = '';
  apiLoading = false;

  get getTitle() {
    return this.config?.title??'';
  }
  get getDesc() {
    return this.config?.desc??''
  }
  get getOkText() {
    return this.config?.okText??'';
  }
  get getCancelText() {
    return this.config?.cancelText??'取消';
  }

  get chooseList() {
    return this.config?.items ?? [];
  }

  close() {
    this.$emit('update:visible', false);
    this.apiLoading = false;
  }

  handleClose() {
    // 处理请求，请求完成后关闭弹窗
    this.apiLoading = true;
    this.$emit('confirm', (success:boolean) => {
      this.apiLoading = false;
      if (success) {
        this.$emit('update:visible', false);
      }
    });
  }

}
